import { useModal } from '@shared/model/useModal';

export const useScheduleModal = () => useModal('schedule');
